<template>
   <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-card-media src="/static/banner.jpg" height="200px">
        </v-card-media>
        <v-card-title primary-title>
              {{message}}
              <v-form v-model="valid" style="width:100%;">
                <v-text-field label="Email" v-model="creds.email" required></v-text-field>
                <v-text-field type="password" label="Password" v-model="creds.password" required></v-text-field>
              </v-form>
        </v-card-title>
        <v-card-actions>
          <v-btn v-on:click="login()" color="primary" style="width:100%;">login</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: 'hello',
  data() {
    return {
      message: null,
      creds: {
          email: '',
          password: ''
      }
    }
  },
  methods: {
      login() {
          this.$store.dispatch("login", this.creds).then(() => {
            this.$router.push("/");
          }).catch((error) => {
            this.message = error.message;
          });
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue